module.exports = {
  background: "#ffffff",
  white: "#ffffff",
  accent: "#d93025",
  bright: "#ffffff",
  dark: "#333333",
  gray: "#555555",
  lightGray: "#bbbbbb",
  superLightGray: "#dedede"
};



// WEBPACK FOOTER //
// ./src/styles/colors.js